<script setup lang="ts">
import $ from 'jquery'

interface PropTypes {
  key?: string
  label?: string
}
const props = withDefaults(
  defineProps<{
    menus?: PropTypes[]
  }>(),
  {
    menus: () => []
  }
)

const { menus } = toRefs(props)

const activeKey = ref<string>(null)

const animateScroll = (value) => {
  activeKey.value = value
  const element = $(`#${value}`)[0]
  const offset = 85
  const offsetTop = element?.offsetTop - offset
  $('html, body').animate(
    {
      scrollTop: offsetTop // Scroll to the top of the page
    },
    0
  )
}

const animateSidebarScroll = (value) => {
  const element = $(`#url_${value}`)[0]
  const offset = 0
  const offsetTop = element?.offsetTop - offset
  $('.static-sidebar').animate(
    {
      scrollTop: offsetTop // Scroll to the top of the page
    },
    0
  )
}

const handleScroll = () => {
  const sectionElements = $('section') // Adjust the selector to match your section elements
  for (const sectionElement of sectionElements) {
    const scrollPosition = $('body').scrollTop()
    const offset = 130
    const rect = sectionElement.getBoundingClientRect()
    const offsetTop = sectionElement?.offsetTop - offset
    const offsetBottom = offsetTop + rect.height

    if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
      activeKey.value = sectionElement?.id
      animateSidebarScroll(activeKey.value)
      break
    }
  }
}

onMounted(() => {
  $('body').on('scroll', handleScroll)
})

onBeforeUnmount(() => {
  $('body').off('scroll', handleScroll)
})

watch(
  () => menus.value,
  (newVal) => {
    activeKey.value = newVal[0]?.key
  },
  { deep: true, immediate: true }
)
</script>

<template>
  <div class="static-sidebar">
    <ul>
      <li v-for="menu in menus" :id="`url_${menu.key}`" :key="menu.key">
        <a
          :class="activeKey === menu.key ? 'active' : null"
          @click="animateScroll(menu.key)"
        >
          {{ menu.label }}
        </a>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@use './styles.scss';
</style>
